import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, App as AntdApp } from 'antd';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import { antdTheme } from './styles/theme';
import './index.css';

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  throw new Error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY environment variable');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={clerkPubKey}
      signInUrl="/login"
      afterSignInUrl="/app"
    >
      <ConfigProvider theme={antdTheme}>
        {/* AntdApp provides modern context for message/notification/modal APIs
            and silences the static-method deprecation warnings emitted by
            antd v5. Components inside can call App.useApp() if needed. */}
        <AntdApp>
          <App />
        </AntdApp>
      </ConfigProvider>
    </ClerkProvider>
  </React.StrictMode>
);
